export const TERMS_OF_USE_FOR_JOB_NAME = "TermsOfUseForJob";
export const TERMS_OF_USE_FOR_PLAN_NAME = "TermsOfUseForPlan";
export const TERMS_OF_USE_FOR_SCOUT_NAME = "TermsOfUseForScout";
export const TERMS_OF_OUTSOURCING_NAME = "TermsOfOutsourcing";
export const EXTERNAL_DATA_PROCESSORS = "ExternalDataProcessors";
